import { isoMinute } from './videoWatermarkIdentity';
import { brandConfig } from '../../config/brandConfig';
import { isPublicTopicSource } from '../../domain/topicSourcePolicy';

const STYLE_ID = 'deepmox-content-trace-style';

export function paintContentTraceLabel(
	host: HTMLElement | null,
	traceCode: string | null | undefined,
	placement: 'audio' | 'article',
	options: { topicSource?: unknown } = {},
): void {
	if (!host) return;
	if (placement === 'audio') {
		const trace = host.querySelector<HTMLElement>('#playerTrace');
		if (!trace) return;
		trace.textContent = traceCode ? `${traceCode} · ${isoMinute()} UTC` : '';
		trace.hidden = !traceCode;
		return;
	}
	const selector = `[data-content-trace-placement="${placement}"]`;
	const existing = host.querySelector<HTMLElement>(selector);
	if (!traceCode) {
		existing?.remove();
		paintArticlePublisher(host, options.topicSource);
		host.hidden = host.querySelector('#article-publisher') === null;
		return;
	}
	ensureStyle(host.ownerDocument ?? document);
	const label = existing ?? host.ownerDocument.createElement('span');
	label.className = `ct-protection-trace ct-protection-trace-${placement}`;
	label.dataset.contentTracePlacement = placement;
	label.textContent = `Trace ID: ${traceCode} · ${isoMinute()} UTC`;
	if (!existing) host.appendChild(label);
	paintArticlePublisher(host, options.topicSource);
	host.hidden = false;
}

function paintArticlePublisher(host: HTMLElement, topicSource: unknown): void {
	if (topicSource === undefined) return;
	const existing = host.querySelector<HTMLElement>('#article-publisher');
	if (!isPublicTopicSource(topicSource)) {
		existing?.remove();
		return;
	}
	if (existing) return;
	const publisher = host.ownerDocument.createElement('span');
	publisher.className = 'article-publisher';
	publisher.id = 'article-publisher';
	publisher.textContent = `Published by ${brandConfig.name}`;
	// Published attribution is the lead line on mobile; Trace remains the
	// secondary line below it without changing the protected trace value.
	host.insertBefore(publisher, host.firstChild);
}

function ensureStyle(doc: Document): void {
	if (doc.getElementById(STYLE_ID)) return;
	const style = doc.createElement('style');
	style.id = STYLE_ID;
	style.textContent = `
		.ct-protection-trace { display:inline-flex; align-items:center; font:600 10px/1.2 ui-monospace,monospace; letter-spacing:.04em; opacity:.48; user-select:none; pointer-events:none; }
		.article-publication-info { display:flex; align-items:baseline; justify-content:space-between; flex-wrap:wrap; gap:8px 24px; min-height:18px; margin:28px 0; }
		.article-publication-info[hidden] { display:none; }
			.article-publication-info .article-publisher { margin-left:auto; color:var(--fg-tertiary); font:600 10px/1.2 var(--font-mono); letter-spacing:.04em; opacity:.58; text-align:right; }
		.ct-protection-trace-article { min-width:0; text-align:left; overflow-wrap:anywhere; }
		@media (max-width:640px) { .article-publication-info { flex-direction:column; align-items:flex-start; text-align:left; } .article-publication-info .article-publisher, .ct-protection-trace-article { margin-left:0; max-width:100%; text-align:left; } }
	`;
	doc.head.appendChild(style);
}
